// 错误
export const GOODSCHANGE_FILE = 'GOODSCHANGE_FILE';
// 更新
export const GOODSCHANGE_UPDATE = 'GOODSCHANGE_UPDATE';
